const { Core, Utils, Events } = Global;
const { $fetch, parseHTML } = Utils;


customElements.define('cart-provider', class extends Core {
    liveSections = new Set();
    notificationsEnabled = false;
    pendingGifts = new Set();
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    render() {
        this.sub(Events.CART_REGISTER, this._registerSection, { global: true });
        this.sub(Events.CART_NOTIFICATIONS_ENABLING, this._enableNotifications, { global: true });
        this.sub(Events.CART_ADD, this._addToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._updateCart, { global: true });
        this.sub(Events.CART_REPLACE, this._replaceCartItem, { global: true });
        this.sub(Events.PRODUCT_FORM_SUBMIT, this._formSubmitHandler, { global: true });

        this._setExternalAPI();
        document.addEventListener('cart:items-added', async (e) => {
            const cart = e.detail.cart;
            console.log('Received cart:items-added event, running free gift logic...');
            
            // OPTIMIZATION: Run free gifts logic first, then sync static product
            // These need to run sequentially because they modify the cart
            // But we don't block the UI - this runs in background
            await this._handleFreeGifts(cart);
            await this._syncStaticProduct();
            
            // Fetch sections and update UI in background
            // User already sees cart drawer, so this is just updating with final data
            const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
            const sections = await sectionRes.json();
            this.pub(Events.CART_UPDATE, {
                sections,
                req: 'freeGifts'
            });
        });
    }

    _registerSection(section) {
        this.liveSections.add(section);
    }

    _enableNotifications() {
        this.notificationsEnabled = true;
    }

   async _formSubmitHandler({ formData }) {
    this.notificationsEnabled && formData.append("attributes[notification_items_variant_ids]", formData.get('id'));
    formData.append("sections", Array.from(this.liveSections).join(','));

    const config = {
        method: 'POST',
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/javascript"
        },
        body: formData
    }
    
    try {
        const res = await fetch(`${window.dynamicURLs['cartAdd']}.js`, config);
        
        const cartData = await res.json();

        if(!res.ok) {
            this.pub(Events.TOAST_NOTIFICATION, {
                type: 'error',
                msg: cartData.description,
                title: cartData.message
            });
            throw new Error(cartData.description);
        }
        const cart = await fetch('/cart.js').then(r => r.json());
        await this._handleFreeGifts(cart);

        await this._syncStaticProduct();

        const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
        const sections = await sectionRes.json();

        this.pub(Events.CART_UPDATE, {
            sections,
            req: "cartAdd"
        })

    } catch (error) {
        console.error(error);
        this.pub(Events.CART_ERROR, error);
    } finally {
        this.notificationsEnabled && this._cleanCartAttributes();
    }
}

    
    async _addToCart({ items }) {
        
        await this._requestCart('cartAdd', {
            items,
            ...(this.notificationsEnabled && { attributes: {
                notification_items_variant_ids: items.map(({id}) => id).join(',')
            }})
        }, items.map(item => item.id));
        this._cleanCartAttributes();
       
    }

    _cleanCartAttributes() {
        this._fetchCart('cartUpdate', { attributes: { notification_items_variant_ids: null }});
    }

    _fetchCart(route, body) {
        return fetch(`${window.dynamicURLs[route]}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(
                body
            )
        })
        
    }

    async _updateCart({ quantity, line }) {
        // NOTE: Terrible, but forced to use line (index) because of unexpected shopify cart API behavior.    
        // TODO: Deprecate line usage    
        await this._requestCart('cartChange', {
            line,
            quantity
        });
    }

    async _replaceCartItem({line, newItem, quantity}) {
        await this._fetchCart('cartChange', {
            line, quantity: 0
        });
        this._addToCart({items: [{ id: newItem, quantity }]});
    }

  /// Custom Function check to add & remove Quantity of Warranty/Subscription Product
     async _syncStaticProduct() {
        // Get subscription product details - use global fallback if not set on current page
        const staticVariantId = window.wproduct?.variant || 31356926853154;
        const sellingPlanId = window.wproduct?.meta?.selling_plan_id || '689283760429';

        if (!staticVariantId) {
            console.warn("🚫 Static product variant ID missing.");
            return;
        }

        try {
            const res = await fetch('/cart.js');
            if (!res.ok) {
                console.warn("⚠️ Failed to fetch /cart.js");
                return;
            }

            const cart = await res.json();
            const items = cart.items || [];

            const hasStatic = items.some(item => item.variant_id === staticVariantId);
            const staticItemIndex = items.findIndex(item => item.variant_id === staticVariantId);
            const staticItem = staticItemIndex !== -1 ? items[staticItemIndex] : null;
            const itemsExceptStatic = items.filter(item => item.variant_id !== staticVariantId);

            // Cart has other items and static not in cart → Add static
            if (itemsExceptStatic.length > 0 && !hasStatic) {
                const addResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: staticVariantId,
                        quantity: 1,
                        ...(sellingPlanId && { selling_plan: sellingPlanId })
                    })
                });

                if (!addResponse.ok) {
                    const errorText = await addResponse.text();
                } else {
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

            // Cart has static, but quantity is not 1 → Fix it
            if (hasStatic && staticItem?.quantity !== 1) {
                const line = staticItemIndex + 1;
                console.log("Adjusting static product quantity to 1...");

                const changeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity: 1 })
                });

                if (!changeRes.ok) {
                    const errText = await changeRes.text();
                    console.error("Failed to update static quantity:", errText);
                } else {
                    console.log("Static product quantity reset to 1.");
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

            // Cart has only static product → Remove it
            if (itemsExceptStatic.length === 0 && hasStatic) {
                const line = staticItemIndex + 1;
                console.log("Removing static product (cart is otherwise empty)...");

                const removeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity: 0 })
                });

                if (!removeRes.ok) {
                    const errText = await removeRes.text();
                } else {
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

        } catch (error) {
            console.error('Error in _syncStaticProduct():', error);
        }
    }


    // End

  
    // async _requestCart(route, body) {
    //     try {
    //         const res = await this._fetchCart(route, {
    //             ...body,
    //             sections: Array.from(this.liveSections).join(','),
    //         });
            
    //         const cartData = await res.json();

    //         if(!res.ok) {
    //             this.pub(Events.TOAST_NOTIFICATION, {
    //                 type: 'error',
    //                 msg: cartData.description,
    //                 title: cartData.message
    //             });
    //             throw new Error(cartData.description);
    //         }  
    //         await this._syncStaticProduct();

    //         this.pub(Events.CART_UPDATE, {
    //             sections: cartData.sections,
    //             req: route
    //         })
          
           
          
    //     } catch (error) {
    //         console.error(error);
    //         this.pub(Events.CART_ERROR, error);
    //     }
    // }

    
       async _handleFreeGifts(cart) {
        const freeProducts = [
            { threshold: 1199, variantId: 40525786120226, title: "Free Mystery Gift" },
            { threshold: 1799, variantId: 51326828937517, title: "Free Mystery Launcher" },
            //{ threshold: 2499, variantId: 51553465237805, title: "Reduced Standard Shipping 3.99" },
          ///  { threshold: 4999, variantId: 51553464484141, title: "Reduced Priority Shipping 4.99" },
            { threshold: 5999, variantId: 51326850335021, title: "Free Random Stadium" },
            { threshold: 6999, variantId: 51326841782573, title: "Free Priority Shipping" }
        ];

        const groupedVariants = {};
        for (const { threshold, variantId } of freeProducts) {
            if (!groupedVariants[variantId]) groupedVariants[variantId] = [];
            groupedVariants[variantId].push(threshold);
        }

        for (const [variantIdStr, thresholds] of Object.entries(groupedVariants)) {
            const variantId = Number(variantIdStr);
            const qualifies = thresholds.some(t => cart.total_price >= t);

            if (this.pendingGifts.has(variantId)) {
                console.log(`Skipping ${variantId} because action already pending`);
                continue;
            }

            let cartItem = cart.items.find(item => item.variant_id === variantId);
            if (qualifies) {
                if (!cartItem) {
                    this.pendingGifts.add(variantId);
                    console.log(`Adding free gift variant ${variantId} with quantity 1`);

                    try {
                        const addRes = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: variantId, quantity: 1 })
                        });

                        if (!addRes.ok) {
                            console.warn(`Failed to add free gift ${variantId}`);
                        } else {
                            console.log(`Successfully added free gift ${variantId}`);
                        }
                    } finally {
                        this.pendingGifts.delete(variantId);
                    }
                }
            } else if (cartItem) {
                console.log(`Removing free gift variant ${variantId}`);

                const line = cart.items.findIndex(item => item.variant_id === variantId) + 1;
                const removeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity: 0 })
                });

                if (!removeRes.ok) {
                    console.warn(`Failed to remove free gift ${variantId}`);
                } else {
                    console.log(`Successfully removed free gift ${variantId}`);
                }
            }
        }
        // Show message for next threshold (at the end) — use the freshest cart snapshot
        const sortedThresholds = [...new Set(freeProducts.map(p => p.threshold))].sort((a, b) => a - b);
        const currentTotal = cart.total_price;
        const nextThreshold = sortedThresholds.find(t => currentTotal < t);
        const messageContainer = document.querySelector('#free-gift-message');

        const currencyCode = Shopify.currency?.active || 'INR';
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2
        });
        if (currentTotal === 0) {
            setTimeout(() => {
                const checkoutButton = document.querySelector('#cart-drawer-live-region-checkout [name="checkout"]');
                
                if (checkoutButton) { 
                    checkoutButton.style.setProperty('display', 'none', 'important');
                    checkoutButton.classList.add('hidden-checkout');
                } else {
                    console.log("Checkout button not found yet");
                }
            }, 1000);
        }


        if (nextThreshold && messageContainer) {
            const remaining = nextThreshold - currentTotal;
            const nextGift = freeProducts.find(p => p.threshold === nextThreshold);
            const productName = nextGift?.title || "a free gift";
            const formatted = formatter.format(remaining / 100);

            messageContainer.innerHTML =
                `You're <span class="free-gift-price">${formatted}</span> away from <span class="free-gift-name">${productName}</span>`;
        } else if (!nextThreshold && messageContainer) {
            messageContainer.textContent = `🎉 You’ve unlocked all available free gifts!`;
        }

        renderGiftProgressBar(currentTotal, freeProducts);
    }



    
    async _requestCart(route, body) {
    try {
        const res = await this._fetchCart(route, {
        ...body,
        sections: Array.from(this.liveSections).join(',')
        });
        const cartData = await res.json();

        if (!res.ok) {
        this.pub(Events.TOAST_NOTIFICATION, {
            type: 'error',
            msg: cartData.description,
            title: cartData.message
        });
        throw new Error(cartData.description);
        }

        // OPTIMIZATION: Fetch cart once and use it for both operations
        // This saves one network request compared to fetching separately
        const cart = await fetch('/cart.js').then(r => r.json());
        
        // Run free gifts and static product sync sequentially
        // They need to run in order because they modify the cart
        await this._handleFreeGifts(cart);   
        await this._syncStaticProduct();
        
        // After adjustments, fetch sections and update UI
        const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
        const sections = await sectionRes.json();
        this.pub(Events.CART_UPDATE, {
            sections,
            req: route 
        });

    } catch (error) {
        console.error('Error in _requestCart with free gift logic:', error);
        this.pub(Events.CART_ERROR, error);
    }
    }

    _setExternalAPI() {
        document.addEventListener('cart:refresh', this._cartRefresh.bind(this));
    }

    async _cartRefresh() {
        const cartSectionsReqURL = `${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`;

        try {
            const data = await fetch(cartSectionsReqURL);
            const sections = await data.json();

            this.pub(Events.CART_UPDATE, {
                sections
            });         
          // Also re-sync static product when cart refresh happens
          //await this._syncStaticProduct();
          
          
        } catch (err) {
            console.error(err);
        }
        
    }
})

customElements.define('cart-qty', class extends Core {
    propTypes = {
        value: Number,
        key: String,
        input: Boolean,
        'prevent-default': Boolean,
        line: Number
    }

    render() {
        this.$({
            [this.evt]: this._handleEvent
        })
    }

    _handleEvent(e) {
        this.prop('prevent-default') && e.preventDefault();
        this.pub(Events.CART_CHANGE, {
            key: this.prop('key'),
            line: this.prop('line'),
            quantity: this._getValue(e)
        })
    }

    _getValue(e) {
        return this.evt === 'change'
            ? this._getValidatedValue(e)
            : this.prop('value'); 
    }

    _getValidatedValue(e) {
        const maxValue = e.target.hasAttribute('max') && +e.target.getAttribute('max');
        if (maxValue && e.target.value > maxValue) {
            e.target.value = maxValue
            return maxValue
        }
        return e.target.value
    }

    get evt() {
        return this.prop('input') 
            ? 'change' 
            : 'click';
    }
});

customElements.define('cart-live-region', class extends Core {
    propTypes = {
        'target-section': String,
        'target-element': String
    }

    render() {
        this.targetSection = this.prop('target-section') || this.sectionId;
        this.targetSelector = this.prop('target-element') || `#${this.id}`;

        customElements.whenDefined('cart-provider').then(() => {
            this.pub(Events.CART_REGISTER, this.targetSection)
        })

        this.sub(Events.CART_UPDATE, this._updateContent, { global: true })
    }
    
    _updateContent({ sections }) {
        const targetSection = sections && sections[this.targetSection];
        if(!targetSection) {
            console.error(`target section ${targetSection} do not exists`);
            return;
        }
        const doc = Utils.parseHTML(targetSection);
        Utils.$replaceContent(this, doc.querySelector(this.targetSelector));

        
    }

})

function renderGiftProgressBar(currentTotal, freeProducts) {
    const container = document.querySelector('#gift-progress-container');
    if (!container) return;

    const thresholds = [...new Set(freeProducts.map(p => p.threshold))].sort((a, b) => a - b);
    const totalGifts = thresholds.length;

    // Match progress fill to last reached index
    const reachedIndex = thresholds.findLastIndex(t => currentTotal >= t);
    const progressPercent = (reachedIndex / (totalGifts - 1)) * 100;

    container.innerHTML = `
        <div class="gift-progress-bar-wrapper">
            <div class="gift-progress-bar-bg">
                <div class="gift-progress-bar-fill" style="width: ${progressPercent}%;"></div>
            </div>
            <div class="gift-progress-markers">
                ${thresholds.map((t, index) => {
                    const leftPercent = (index / (totalGifts - 1)) * 100;
                    const reached = currentTotal >= t;
                    const gift = freeProducts.find(p => p.threshold === t);

                    return `
                        <div class="gift-marker ${reached ? 'reached' : ''}" style="left: ${leftPercent}%; top: 0;">
                            <div class="gift-icon">
                                <div class="gift_icon">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAk0lEQVR4nO3PMQrCQBRF0Q82EZcQLMQNWtkJWrgfERQLd2MlpE95JDiICELIBJGQCwPzecO/byL+DexR4YYdJjnLSpxR44pVmst0jtjmCE5YY4qNJ4u3fI57jqDGLN2LZvtH3giqHMEhNS/S/BJgiUvzw7bLeiO+CdqUiK5vhiHoi+jaUGY+CmIUxCiInwhyicHxAP4T9IRxken4AAAAAElFTkSuQmCC" alt="gift">
                                </div>
                            </div>
                            <div class="gift-title">${gift?.title || "Gift"}</div>
                        </div>
                    `;
                }).join('')}
            </div>
        </div>
    `;
}


